<template lang="pug">
div( class="d-flex flex-column flex-grow-1 min-h-0 fill-height overflow-hidden add-pitch-modal"  )
	div( class=" tw-flex tw-flex-row tw-flex-grow-0 tw-p-4 tw-pb-1 tw-text-left" )
		v-row
			v-col
				span( class=" tw-text-2xl text-secondary tw-font-bold ") Pitch a new property
	div(class=" tw-flex tw-flex-row tw-flex-grow tw-overflow-y-scroll tw-p-4 tw-pl-2 tw-pb-0 tw-mb-0" )
		v-row(align-self="start" class=" tw-flex tw-flex-row tw-h-full tw-flex-grow tw-p-2 tw-pt-0  tw-pb-0 tw-mb-0")
			v-col(class="  tw-flex tw-flex-col tw-flex-grow tw-pb-0 tw-mb-0")
				kubiqa-pitches-list-item(v-for="property in properties" :key="property.id" :item="property" class="tw-mb-1")

	div(class="tw-flex tw-flex-row tw-flex-grow-0 tw-p-4 tw-pt-1")
		v-row(justify="end" align-self="end" align="end" class="tw-bottom-0")
			v-col(cols="auto" class="tw-h-full fill-height")
				v-btn( @click="save" depressed color="rgba(94,129,244,0.80)" :loading="loading" width="90px"  ) 
					span(class="tw-font-bold" ) Save


							
                    
				
</template>

<script>
export default {
	data(){
		return {
			loading: false
		}
	},
	computed: {
		properties(){
			return this.$store.getters['properties/properties']
		},
		selection(){
			return this.$store.getters['opportunities/pitches/selection']
		},
		opportunity(){
			return this.$route.params.id
		}
	},
	mounted(){
		this.$store.dispatch('properties/getProperties')
		this.$store.commit('opportunities/pitches/SET_SELECTION', [])
	},
	methods:{
		async save(){
			if(this.selection.length > 0){
				await this.$store.dispatch('opportunities/pitches/add', [this.opportunity, this.selection])
					.then(response => {
						this.$emit('close')
						this.$store.commit('opportunities/pitches/SET_SELECTION', [])
					})
					.catch(error => {
						commit('SET_ERROR', error, {root: true})
					})
			}else{
				console.log('No selection')
			}

		}
	}
}
</script>

<style>
.add-pitch-modal{
	height: 80vh !important;
	max-height: 600px;
}
</style>